import React from "react";
import { ActivityIndicator, Pressable, StyleSheet, Text, View } from "react-native";
import { InfoCircleIcon } from "../assets/icons";

export function SectionHeading({ Icon, title, actionLabel, onAction }) {
  return (
    <View style={styles.sectionHeading}>
      <View style={styles.iconTile}>
        <Icon width={17} height={17} customColor="#5423B5" stroke="#5423B5" />
      </View>
      <Text style={styles.sectionTitle}>{title}</Text>
      {!!actionLabel && (
        <Pressable onPress={onAction} disabled={!onAction} style={styles.actionBadge}>
          <Text style={styles.actionLabel}>{actionLabel}</Text>
        </Pressable>
      )}
    </View>
  );
}

export function CategoryLoadingCard({ Icon, title, actionLabel, loading, loadError }) {
  return (
    <View style={styles.card}>
      <SectionHeading Icon={Icon} title={title} actionLabel={actionLabel} />
      <View style={styles.divider} />
      <View style={styles.categoryLoading}>
        {loading ? <ActivityIndicator size="small" color="#6724E2" /> : <InfoCircleIcon width={20} height={20} customColor="#999999" />}
        <Text style={styles.categoryLoadingText}>
          {loading ? `Memuat ${title.toLowerCase()}...` : `Data ${title.toLowerCase()} gagal dimuat.`}
        </Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  card: { padding: 14, borderRadius: 14, backgroundColor: "#FFFFFF", elevation: 2, shadowColor: "#34234A", shadowOpacity: 0.08, shadowRadius: 5, shadowOffset: { width: 0, height: 2 } },
  sectionHeading: { minHeight: 26, flexDirection: "row", alignItems: "center", gap: 8 },
  iconTile: { width: 28, height: 28, borderRadius: 6, backgroundColor: "#F0E9FF", alignItems: "center", justifyContent: "center" },
  sectionTitle: { flex: 1, color: "#171717", fontFamily: "Archivo-Bold", fontSize: 13 },
  actionBadge: { paddingHorizontal: 10, paddingVertical: 6, borderRadius: 18, backgroundColor: "#F0E9FF" },
  actionLabel: { color: "#6724E2", fontFamily: "Archivo-Regular", fontSize: 9 },
  divider: { height: 1, marginTop: 10, marginBottom: 5, backgroundColor: "#EEEEEE" },
  categoryLoading: { minHeight: 88, flexDirection: "row", alignItems: "center", justifyContent: "center", gap: 10 },
  categoryLoadingText: { color: "#777777", fontFamily: "Archivo-Regular", fontSize: 11 },
});
